module.exports = __webpack_public_path__ + "img/bg_5.dbe5cfdf.jpg";